import React, { Component, Fragment } from "react";
import { Redirect, Link } from "react-router-dom";
import * as Yup from "yup";
import AlertComponent from "../../common/AlertComponent";
import { Formik, Form, Field } from "formik";
import HttpUtil from "../../common/HttpUtil";
import {
  STATES_API,
  COUNTRIES_API,
  FUND_AGENCY_API
} from "../../common/Constants";

function getError(touch, error, fieldName) {
  return touch && touch[fieldName] && error && error[fieldName];
}

function getErrorCssClassName(touch, error, fieldName) {
  return getError(touch, error, fieldName) ? "is-invalid" : "";
}

const ErrorComponent = props => {
  const { fieldName, touch, error, datePicker } = props;
  let renderComponent = "";

  if (datePicker) {
    renderComponent = (
      <div className="auto-lookup-empty">
        {touch[`${fieldName}`] && error[`${fieldName}`]}
      </div>
    );
  } else {
    renderComponent = (
      <div className="invalid-feedback">
        {touch[`${fieldName}`] && error[`${fieldName}`]}
      </div>
    );
  }
  return renderComponent;
};

const FundingAgencyForm = props => {
  const { values, touched, errors } = props;
  const disabledField = values.readOnly
    ? { readOnly: "readonly", disabled: "disabled" }
    : {};
  return (
    <Form>
      <div className="shadow card flex-fill box-border box-light-blue">
        <div className="card-header border-0 text-center  pb-0">
          <span className="float-left">
            <Link to="/funding/agencies" className="text-light-blue">
              <i className="fas fa-arrow-left" />
            </Link>
          </span>
          <h6 className="mb-0 d-inline-block text-light-blue">
            <strong>{values.formTitle}</strong>
          </h6>
        </div>

        <div className="card-body pt-2">
          <div className="card border-0 h-100">
            <div className="card-header border-0 pb-0">
              <strong className="border-bottom pb-1 d-block text-muted">
                Agency Information
              </strong>
            </div>
            <div className="card-body pt-2">
              <div className="form-group row mb-2">
                <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                  Agency Name
                </label>
                <div className="col-12 col-lg-6 col-xl-6">
                  <Field
                    type="text"
                    className={`form-control form-control-sm ${getErrorCssClassName(
                      touched,
                      errors,
                      "name"
                    )}`}
                    name="name"
                    {...disabledField}
                  />
                  <ErrorComponent
                    fieldName="name"
                    touch={touched}
                    error={errors}
                  />
                </div>
              </div>

              <div className="form-group row mb-2">
                <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                  Full Name
                </label>
                <div className="col-12 col-lg-6 col-xl-6">
                  <Field
                    type="text"
                    className={`form-control form-control-sm ${getErrorCssClassName(
                      touched,
                      errors,
                      "fullName"
                    )}`}
                    name="fullName"
                    {...disabledField}
                  />
                  <ErrorComponent
                    fieldName="fullName"
                    touch={touched}
                    error={errors}
                  />
                </div>
              </div>

              <div className="form-group row mb-2">
                <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                  Agency Type
                </label>
                <div className="col-12 col-lg-6 col-xl-6">
                  <Field
                    component="select"
                    type="text"
                    className={`custom-select custom-select-sm ${getErrorCssClassName(
                      touched,
                      errors,
                      "type"
                    )}`}
                    name="agencyType"
                    {...disabledField}
                  >
                    <option value="">Select...</option>
                    <option value="STATE">State</option>
                    <option value="CENTRAL">Central</option>
                  </Field>
                  <ErrorComponent
                    fieldName="agencyType"
                    touch={touched}
                    error={errors}
                  />
                </div>
              </div>

              {values.agencyType === "STATE" ? (
                <div className="form-group row mb-2">
                  <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                    State
                  </label>
                  <div className="col-12 col-lg-6 col-xl-6">
                    <Field
                      component="select"
                      type="text"
                      className={`custom-select custom-select-sm ${getErrorCssClassName(
                        touched,
                        errors,
                        "state"
                      )}`}
                      name="state"
                      {...disabledField}
                    >
                      <option value="">Select...</option>
                      {values.states.map((state, i) => (
                        <option key={i} value={state.stateCode}>
                          {state.stateName}
                        </option>
                      ))}
                    </Field>
                    <ErrorComponent
                      fieldName="state"
                      touch={touched}
                      error={errors}
                    />
                  </div>
                </div>
              ) : null}

              <div className="form-group row mb-2">
                <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                  Grant Description
                </label>
                <div className="col-12 col-lg-6 col-xl-6">
                  <Field
                    component="textarea"
                    className={`form-control form-control-sm ${getErrorCssClassName(
                      touched,
                      errors,
                      "description"
                    )}`}
                    name="description"
                    rows="5"
                    {...disabledField}
                  />
                  <ErrorComponent
                    fieldName="description"
                    touch={touched}
                    error={errors}
                  />
                </div>
              </div>
              {/* 
              <div className="form-group row mb-2">
                <label className="col-form-label col-form-label-sm col-12 col-lg-3 col-xl-3">
                  Country
                </label>
                <div className="col-12 col-lg-6 col-xl-6">
                  <Field
                    component="select"
                    type="text"
                    className={`custom-select custom-select-sm ${getErrorCssClassName(
                      touched,
                      errors,
                      "country"
                    )}`}
                    name="country"
                    {...disabledField}
                  >
                    <option value="">Select...</option>
                    {values.countries.map((country, i) => (
                      <option key={i} value={country.countryCode}>
                        {country.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorComponent
                    fieldName="country"
                    touch={touched}
                    error={errors}
                  />
                </div>
              </div> */}
            </div>
          </div>
          <div className="row mb-2 mt-2">
            <div className="col-12 text-center">
              <button className="btn btn-sm btn-primary" type="submit">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

const FUNDING_AGENCY_SCHEMA = Yup.object().shape({
  name: Yup.string()
    .label("Agency Name")
    .required(),
  fullName: Yup.string()
    .label("Agency Full Name")
    .required(),
  agencyType: Yup.string()
    .label("Agency Type")
    .required(),
  description: Yup.string()
    .label("Agency Description")
    .required(),
  state: Yup.string().when("agencyType", {
    is: "STATE",
    then: Yup.string()
      .label("Agency State")
      .required()
  }),
  country: Yup.string()
    .label("Agency Country")
    .required()
});

class FundingAgencyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundingAgency: {
        _id: "",
        name: "",
        fullName: "",
        agencyType: "",
        state: "",
        country: "IN",
        description: "",
        states: [],
        countries: [],
        formTitle: null,
        readOnly: false
      },

      editFundingAgency: false,
      editFundingAgencyId: null
    };
  }

  // api failed  response alert to user
  handleApiFailed = message => {
    this.setState({
      alertType: "Default",
      showAlert: true,
      alertColor: "danger",
      alertMessage: message
    });
    window.scrollTo(0, 0);
  };

  // close alert message
  closeDefaultAlert = () => {
    this.setState({
      alertType: "",
      showAlert: false,
      alertColor: "",
      alertMessage: ""
    });
  };

  getStates = () => {
    const url = STATES_API;
    HttpUtil.get(
      url,
      {},
      data => {
        const fundingAgency = { ...this.state.fundingAgency };
        fundingAgency.states = data;
        this.setState({ fundingAgency });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  getCountries = () => {
    const url = COUNTRIES_API;
    HttpUtil.get(
      url,
      {},
      data => {
        const fundingAgency = { ...this.state.fundingAgency };
        fundingAgency.countries = data;
        this.setState({ fundingAgency });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  getFundingAgency = id => {
    if (this.props.location.state && this.props.location.state.created) {
      this.setState({
        alertType: "Default",
        showAlert: true,
        alertColor: "success",
        alertMessage: `Funding Agency has been created successfully.`
      });
      window.scrollTo(0, 0);
    }

    const url = `${FUND_AGENCY_API}/${id}`;
    HttpUtil.get(
      url,
      {},
      data => {
        const fundingAgency = { ...this.state.fundingAgency };
        fundingAgency._id = data._id || "";
        fundingAgency.name = data.name || "";
        fundingAgency.fullName = data.fullName || "";
        fundingAgency.agencyType = data.agencyType || "";
        fundingAgency.description = data.description || "";
        fundingAgency.state = data.state || "";
        fundingAgency.country = data.country || "IN";
        fundingAgency.formTitle = `Agency - ${data.name}`;
        this.setState({ fundingAgency });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  createFundingAgency = (values, setSubmitting) => {
    setSubmitting(true);

    const createRequest = {
      name: values.name,
      fullName: values.fullName,
      agencyType: values.agencyType,
      description: values.description,
      state: values.agencyType === "STATE" ? values.state : undefined,
      country: values.country
    };

    const url = `${FUND_AGENCY_API}`;
    const headers = { "Content-Type": "application/json" };

    HttpUtil.post(
      url,
      headers,
      createRequest,
      data => {
        setSubmitting(false);
        this.setState({
          editFundingAgency: true,
          editFundingAgencyId: data._id
        });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  updateFundingAgency = (values, setSubmitting) => {
    setSubmitting(true);

    const updateRequest = {
      name: values.name,
      fullName: values.fullName,
      agencyType: values.agencyType,
      description: values.description,
      state: values.agencyType === "STATE" ? values.state : undefined,
      country: values.country
    };

    const id = this.props.match.params.id;
    const url = `${FUND_AGENCY_API}/${id}`;
    const headers = { "Content-Type": "application/json" };

    HttpUtil.put(
      url,
      headers,
      updateRequest,
      data => {
        setSubmitting(false);
        this.getFundingAgency(data._id);
        this.setState({
          alertType: "Default",
          showAlert: true,
          alertColor: "success",
          alertMessage: `Funding Agency "${
            data.name
          }" has been updated successfully.`
        });
        window.scrollTo(0, 0);
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  handleSubmit = (values, { setSubmitting }) => {
    // console.log("submit : values:", JSON.stringify(values, null, 2));
    const fundingAgency = this.state.fundingAgency;

    if (fundingAgency._id) {
      this.updateFundingAgency(values, setSubmitting);
    } else {
      this.createFundingAgency(values, setSubmitting);
    }
  };

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const id = match.params.id;
      this.getFundingAgency(id);
    } else {
      const fundingAgency = { ...this.state.fundingAgency };
      fundingAgency.formTitle = "New Funding Agency";
      this.setState({ fundingAgency });
    }
    this.getCountries();
    this.getStates();
  }

  render() {
    const { editFundingAgency, editFundingAgencyId } = this.state;

    if (editFundingAgency) {
      const stateObj = {
        pathname: `/funding/agencies/edit/${editFundingAgencyId}`,
        state: { created: true }
      };

      return <Redirect to={stateObj} />;
    }

    const alertProps = {
      show: this.state.showAlert,
      type: this.state.alertType,
      alertColor: this.state.alertColor,
      message: this.state.alertMessage,
      close: this.closeDefaultAlert
    };

    const props = {
      initialValues: this.state.fundingAgency,
      validationSchema: FUNDING_AGENCY_SCHEMA,
      handleSubmit: this.handleSubmit
    };
    return (
      <Fragment>
        <div className="row mb-3">
          <div className="col-md-12">
            <AlertComponent {...alertProps} />
          </div>
        </div>

        <Formik
          enableReinitialize
          initialValues={props.initialValues}
          validationSchema={props.validationSchema}
          onSubmit={(values, { setSubmitting }) =>
            props.handleSubmit(values, { setSubmitting })
          }
          render={({
            values,
            isSubmitting,
            errors,
            touched,
            setFieldValue
          }) => {
            const formProps = {
              values,
              isSubmitting,
              errors,
              touched,
              setFieldValue
            };
            return <FundingAgencyForm {...formProps} />;
          }}
        />
      </Fragment>
    );
  }
}

export default FundingAgencyDetail;
